function interval(cb, timeout) {
  const i = setInterval(cb, timeout);
  return () => clearInterval(i);
}
export {
  interval
};
//# sourceMappingURL=interval.mjs.map
